'use client';

import { useEffect, useRef } from 'react';

import { JumpLinkType, useJumpLinks } from '@/providers';

export interface JumpLinkDestinationProps {
  id: string;
  navLabel: JumpLinkType['navLabel'];
  topOffset?: number;
}

export function JumpLinkDestination({
  id,
  navLabel,
  topOffset = 40,
}: Omit<JumpLinkType, 'destinationRef'>) {
  const { addJumpLink } = useJumpLinks();
  const destinationRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    addJumpLink({
      id,
      navLabel,
      destinationRef,
      topOffset,
    });
  }, [id, navLabel, topOffset, addJumpLink]);

  return (
    <div
      ref={destinationRef}
      style={{ scrollMarginTop: topOffset }}
      data-jumplink-id={id}
    />
  );
}
